import {
  JsonElementSerializer_getInstanceqpm5aw7w4cej as JsonElementSerializer_getInstance,
  JsonPrimitiveSerializer_getInstance7mj253uvdtw6 as JsonPrimitiveSerializer_getInstance,
  JsonObjectSerializer_getInstance15ehqyi55oo4q as JsonObjectSerializer_getInstance,
  JsonArraySerializer_getInstance2u75x9rgsas6i as JsonArraySerializer_getInstance,
  JsonNullSerializer_getInstancejguwsicwxpex as JsonNullSerializer_getInstance,
} from './JsonElementSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  printQuotedmgc3s3pgfors as printQuoted,
  toBooleanStrictOrNull2hf9surgqf5vr as toBooleanStrictOrNull,
} from './internal/StringOps.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Default_getInstancevb13yk0g3h3e as Default_getInstance } from './Json.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return JsonElementSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var JsonElementClass;
function JsonElement() {
  if (JsonElementClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
    JsonElementClass = $;
  }
  return JsonElementClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var JsonPrimitiveClass;
function JsonPrimitive() {
  if (JsonPrimitiveClass === VOID) {
    class $ extends JsonElement() {
      toString() {
        return this.get_content_h02jrk_k$();
      }
    }
    initMetadataForClass($, 'JsonPrimitive', VOID, VOID, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
    JsonPrimitiveClass = $;
  }
  return JsonPrimitiveClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.get_key_18j28a_k$();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.get_value_j01efc_k$();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  printQuoted(this_0, k);
  this_0.append_58al37_k$(_Char___init__impl__6a9atx(58));
  this_0.append_t8pm91_k$(v);
  return this_0.toString();
}
var JsonObjectClass;
function JsonObject() {
  if (JsonObjectClass === VOID) {
    class $ extends JsonElement() {
      constructor(content) {
        super();
        this.content_1 = content;
      }
      equals(other) {
        return equals(this.content_1, other);
      }
      hashCode() {
        return hashCode(this.content_1);
      }
      toString() {
        var tmp = this.content_1.get_entries_p20ztl_k$();
        return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
      }
      isEmpty_y1axqb_k$() {
        return this.content_1.isEmpty_y1axqb_k$();
      }
      containsKey_w445h6_k$(key) {
        return this.content_1.containsKey_aw81wo_k$(key);
      }
      containsKey_aw81wo_k$(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.containsKey_w445h6_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      get_6bo4tg_k$(key) {
        return this.content_1.get_wei43m_k$(key);
      }
      get_wei43m_k$(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.get_6bo4tg_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      get_size_woubt6_k$() {
        return this.content_1.get_size_woubt6_k$();
      }
      get_keys_wop4xp_k$() {
        return this.content_1.get_keys_wop4xp_k$();
      }
      get_values_ksazhn_k$() {
        return this.content_1.get_values_ksazhn_k$();
      }
      get_entries_p20ztl_k$() {
        return this.content_1.get_entries_p20ztl_k$();
      }
    }
    initMetadataForClass($, 'JsonObject', VOID, VOID, [KtMap()], VOID, VOID, {0: JsonObjectSerializer_getInstance});
    JsonObjectClass = $;
  }
  return JsonObjectClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var JsonArrayClass;
function JsonArray() {
  if (JsonArrayClass === VOID) {
    class $ extends JsonElement() {
      constructor(content) {
        super();
        this.content_1 = content;
      }
      equals(other) {
        return equals(this.content_1, other);
      }
      hashCode() {
        return hashCode(this.content_1);
      }
      toString() {
        return joinToString(this.content_1, ',', '[', ']');
      }
      isEmpty_y1axqb_k$() {
        return this.content_1.isEmpty_y1axqb_k$();
      }
      contains_ba8w01_k$(element) {
        return this.content_1.contains_aljjnj_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!(element instanceof JsonElement()))
          return false;
        return this.contains_ba8w01_k$(element instanceof JsonElement() ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        return this.content_1.iterator_jk1svi_k$();
      }
      containsAll_f3qvbt_k$(elements) {
        return this.content_1.containsAll_bwkf3g_k$(elements);
      }
      containsAll_bwkf3g_k$(elements) {
        return this.containsAll_f3qvbt_k$(elements);
      }
      get_c1px32_k$(index) {
        return this.content_1.get_c1px32_k$(index);
      }
      indexOf_tu0qjb_k$(element) {
        return this.content_1.indexOf_si1fv9_k$(element);
      }
      indexOf_si1fv9_k$(element) {
        if (!(element instanceof JsonElement()))
          return -1;
        return this.indexOf_tu0qjb_k$(element instanceof JsonElement() ? element : THROW_CCE());
      }
      listIterator_70e65o_k$(index) {
        return this.content_1.listIterator_70e65o_k$(index);
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        return this.content_1.subList_xle3r2_k$(fromIndex, toIndex);
      }
      get_size_woubt6_k$() {
        return this.content_1.get_size_woubt6_k$();
      }
    }
    initMetadataForClass($, 'JsonArray', VOID, VOID, [KtList()], VOID, VOID, {0: JsonArraySerializer_getInstance});
    JsonArrayClass = $;
  }
  return JsonArrayClass;
}
var JsonNullClass;
function JsonNull() {
  if (JsonNullClass === VOID) {
    class $ extends JsonPrimitive() {
      constructor() {
        JsonNull_instance = null;
        super();
        JsonNull_instance = this;
        this.content_1 = 'null';
      }
      get_content_h02jrk_k$() {
        return this.content_1;
      }
      serializer_9w0wvi_k$() {
        return JsonNullSerializer_getInstance();
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForObject($, 'JsonNull', VOID, VOID, [SerializerFactory()], VOID, VOID, {0: JsonNullSerializer_getInstance});
    JsonNullClass = $;
  }
  return JsonNullClass;
}
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new (JsonNull())();
  return JsonNull_instance;
}
var JsonLiteralClass;
function JsonLiteral() {
  if (JsonLiteralClass === VOID) {
    class $ extends JsonPrimitive() {
      constructor(body, isString, coerceToInlineType) {
        coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
        super();
        this.isString_1 = isString;
        this.coerceToInlineType_1 = coerceToInlineType;
        this.content_1 = toString(body);
        if (!(this.coerceToInlineType_1 == null)) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.coerceToInlineType_1.get_isInline_usk17w_k$()) {
            var message = 'Failed requirement.';
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
        }
      }
      get_content_h02jrk_k$() {
        return this.content_1;
      }
      toString() {
        var tmp;
        if (this.isString_1) {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
          printQuoted(this_0, this.content_1);
          tmp = this_0.toString();
        } else {
          tmp = this.content_1;
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof JsonLiteral()))
          THROW_CCE();
        if (!(this.isString_1 === other.isString_1))
          return false;
        if (!(this.content_1 === other.content_1))
          return false;
        return true;
      }
      hashCode() {
        var result = getBooleanHashCode(this.isString_1);
        result = imul(31, result) + getStringHashCode(this.content_1) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'JsonLiteral');
    JsonLiteralClass = $;
  }
  return JsonLiteralClass;
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive() ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull()) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.get_content_h02jrk_k$();
  }
  return tmp;
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull(_this__u8e3s4.get_content_h02jrk_k$());
}
function parseLongImpl(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return StringJsonLexer(Default_getInstance(), _this__u8e3s4.get_content_h02jrk_k$()).consumeNumericLiteralFully_dgqq24_k$();
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.get_content_h02jrk_k$();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.get_content_h02jrk_k$());
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, true);
}
function JsonPrimitive_1(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, false);
}
function JsonPrimitive_2(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, false);
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance3ijxvfrz0dm1u,
  JsonNull_getInstance as JsonNull_getInstance1i1hv1sbjynto,
  JsonArray as JsonArray2urf8ey7u44sd,
  JsonElement as JsonElementf07o4p6p57al,
  JsonLiteral as JsonLiteral1u57id0qmqut7,
  JsonNull as JsonNull2liwjj96vm0w2,
  JsonObject as JsonObjectee06ihoeeiqj,
  JsonPrimitive_0 as JsonPrimitiveolttw629wj53,
  JsonPrimitive_1 as JsonPrimitive2fp8648nd60dn,
  JsonPrimitive_2 as JsonPrimitive1xkjzc5d7ihuv,
  JsonPrimitive as JsonPrimitive3ttzjh2ft5dnx,
  get_booleanOrNull as get_booleanOrNull376axlcpdhkmo,
  get_contentOrNull as get_contentOrNull35s97cgi8z9eo,
  get_double as get_double1785hcxaminy4,
  get_float as get_float1xtaobzj8js8m,
  get_jsonPrimitive as get_jsonPrimitivez17tyd5rw1ql,
  get_jsonUnquotedLiteralDescriptor as get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf,
  parseLongImpl as parseLongImpl2gkj8byk018b9,
};
//endregion

//# sourceMappingURL=JsonElement.mjs.map
